import { Checkbox } from 'src/components/ui/checkbox';
import { Controller } from 'react-hook-form';
import React from 'react';
import { clsx } from 'clsx';

export const WorkflowActionFieldName = ({
  namePrefix = 'action.0',
  control,
  trigger = (() => {}) as (fields?: any) => void,
}) => {
  const idPrefix = namePrefix.split('.')[1];

  return (
    <div className="flex flex-row items-center space-x-2.5">
      <Controller
        control={control}
        name={`${namePrefix}.action_fields_name`}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <div className={'flex flex-row items-center space-x-2.5'}>
              <label
                htmlFor={`${idPrefix}action_fields_name`}
                className={clsx(
                  'flex flex-row items-center gap-2.5 font-medium text-sm text-ebony_opacity_50 cursor-pointer leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
                  error?.message && 'text-error',
                )}
              >
                <Checkbox
                  id={`${idPrefix}action_fields_name`}
                  defaultValue={value}
                  checked={value}
                  onCheckedChange={(val) => {
                    onChange(val);
                    trigger([
                      `${namePrefix}.action_fields_phone_number`,
                      `${namePrefix}.action_fields_name`,
                      `${namePrefix}.action_fields_email`,
                      `${namePrefix}.action_fields_custom`,
                      `${namePrefix}.action_data_collection`,
                    ]);
                  }}
                  className={clsx(error?.message && 'border-error')}
                />
                Name
              </label>
            </div>
          );
        }}
      />
    </div>
  );
};
